<script>
  import { RouterOutlet } from 'svelte-easyroute';

  export let router;
</script>

<style lang="scss">
  .main {
    display: flex;
    justify-content: center;
  }

  .main :global(.easyroute-outlet) {
    width: 1905px;
  }
</style>

<main class="main">
  <RouterOutlet router={router} />
</main>
